import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#tabs" }),
    /*#__PURE__*/_createTextVNode(" Tabs ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Divide data collections which are related yet belong to different types. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUICardStyle = _resolveComponent("EUICardStyle")
  const _component_EUIBorderCard = _resolveComponent("EUIBorderCard")
  const _component_EUITabPosition = _resolveComponent("EUITabPosition")
  const _component_EUICustomTab = _resolveComponent("EUICustomTab")
  const _component_EUIAddAndCloseTab = _resolveComponent("EUIAddAndCloseTab")
  const _component_EUICustomizedTriggerButtonOfNewTab = _resolveComponent("EUICustomizedTriggerButtonOfNewTab")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUICardStyle),
    _createVNode(_component_EUIBorderCard),
    _createVNode(_component_EUITabPosition),
    _createVNode(_component_EUICustomTab),
    _createVNode(_component_EUIAddAndCloseTab),
    _createVNode(_component_EUICustomizedTriggerButtonOfNewTab)
  ], 64))
}